import { render, staticRenderFns } from "./ChartOfAccountModal.vue?vue&type=template&id=04aee062&"
import script from "./ChartOfAccountModal.vue?vue&type=script&lang=js&"
export * from "./ChartOfAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports